import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaPesquisaCivil } from './types';

export const INITIAL_STATE: ConsultaPesquisaCivil = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaPesquisaCivil {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_PESQUISA_CIVIL_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.CONSULTA_PESQUISA_CIVIL_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTA_PESQUISA_CIVIL_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTA_PESQUISA_CIVIL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}

		return draft;
	});
}
